/* Mondro: marks the home section being read, closes the phone menu after a tap.
   Optional: every page works without it. The only JavaScript of the Mondro theme. */
(function () {
  var menu = document.querySelector('.nav-menu');
  if (menu) menu.addEventListener('click', function (e) {
    if (e.target.closest('a')) menu.removeAttribute('open');
  });
  var links = document.querySelectorAll('.site-nav a[href^="#"]');
  if (!links.length || !('IntersectionObserver' in window)) return;
  function mark(id) {
    for (var i = 0; i < links.length; i++) {
      if (id && links[i].hash === '#' + id) links[i].setAttribute('aria-current', 'location');
      else links[i].removeAttribute('aria-current');
    }
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) mark(e.target.getAttribute('data-nav')); });
  }, { rootMargin: '-35% 0px -64% 0px' });
  /* In the theme every section sits inside a wrapper div, so the sections are found by
     their data-nav attribute (the static site used "main > section"). */
  document.querySelectorAll('main [data-nav]').forEach(function (s) { io.observe(s); });
})();
